// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssignTaskConfirmation-module__container {
  width: 552px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.AssignTaskConfirmation-module__container p {
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 174%;
  letter-spacing: 0%;
  text-align: center;
}
.AssignTaskConfirmation-module__closeHeader{
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
}
.AssignTaskConfirmation-module__closeHeader button{
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
}
.AssignTaskConfirmation-module__headingtext {
  font-family: Montserrat;
  font-weight: 600;
  font-size: 18px;
  line-height: 167%;
  letter-spacing: 0%;
  vertical-align: middle;
}

.AssignTaskConfirmation-module__confirmationIcon {
  margin-top: 20px;
  margin-bottom: 20px;
}

.AssignTaskConfirmation-module__btnContainer {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.AssignTaskConfirmation-module__startEvaluationBtn {
  width: 289px;
  height: 45px;
  gap: 10px;
  angle: 0 deg;
  opacity: 1;
  border-radius: 56px;
  padding-top: 14px;
  padding-right: 64px;
  padding-bottom: 14px;
  padding-left: 64px;
  background-color: #263643;
  font-family: Montserrat;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 8%;
  text-align: center;
  text-transform: uppercase;

  color: #ffffff;
  border: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/modals/assigntaskconfirmation/AssignTaskConfirmation.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;;EAEzB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".container {\n  width: 552px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.container p {\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  line-height: 174%;\n  letter-spacing: 0%;\n  text-align: center;\n}\n.closeHeader{\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    cursor: pointer;\n}\n.closeHeader button{\n    background: none;\n    border: none;\n    font-size: 18px;\n    cursor: pointer;\n}\n.headingtext {\n  font-family: Montserrat;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 167%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n}\n\n.confirmationIcon {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.btnContainer {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.startEvaluationBtn {\n  width: 289px;\n  height: 45px;\n  gap: 10px;\n  angle: 0 deg;\n  opacity: 1;\n  border-radius: 56px;\n  padding-top: 14px;\n  padding-right: 64px;\n  padding-bottom: 14px;\n  padding-left: 64px;\n  background-color: #263643;\n  font-family: Montserrat;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 100%;\n  letter-spacing: 8%;\n  text-align: center;\n  text-transform: uppercase;\n\n  color: #ffffff;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AssignTaskConfirmation-module__container`,
	"closeHeader": `AssignTaskConfirmation-module__closeHeader`,
	"headingtext": `AssignTaskConfirmation-module__headingtext`,
	"confirmationIcon": `AssignTaskConfirmation-module__confirmationIcon`,
	"btnContainer": `AssignTaskConfirmation-module__btnContainer`,
	"startEvaluationBtn": `AssignTaskConfirmation-module__startEvaluationBtn`
};
export default ___CSS_LOADER_EXPORT___;
